import React, { useContext } from "react"
import TpTaxVarianceReportHelpPanel from "./TpTaxVarianceReportHelpPanel"
import CONSTANTS from "src/utils/constants";
import { GlobalAppContext } from "../App";
import ContactSupport from "./ContactSupport";

const HELP_PANEL_MAP = new Map<string, React.JSX.Element>();
HELP_PANEL_MAP.set(CONSTANTS.PAGE_NAV.TP_TAX_VARIANCE_RECORD.HEADER_SIDEBAR_KEY, <TpTaxVarianceReportHelpPanel />);


export default function ATPHelpPanel() {
    const { globalState } = useContext(GlobalAppContext);
    const { pageSidebarKey = '' } = globalState;

    return pageSidebarKey == '' ? <ContactSupport /> : HELP_PANEL_MAP.get(pageSidebarKey) || <ContactSupport />
}